import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostAppointmentLinkBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useCreateAppointmentLink() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: PostAppointmentLinkBody) => {
      const response = await api.post('/appointments/link', { body: input })
      if (!response.success) throw new Error(response.error.message)
      return response.data.url
    },
    onSuccess: () => {
      // Invalidate all appointment queries so the new booking appears immediately
      queryClient.invalidateQueries({ queryKey: ['appointments'] })
    },
  })
}
